import NewsCategory from '../../../api/newsCategoryEntity';
import {newsContentManager} from '../../../api/newsContentManager';

import TopicListItemsDto from '../../../api/topicListItemsDto';
import { notifyBreadcrumChangeAction } from '../../../common/components/breadcrumb/actions/notifyBreadcrumChange';
import { actionTypes } from '../../../common/constants/actionTypes';

import { httpCallStartAction } from '../../../middlewares/http/actions';

export const fetchTopicItemsAction = (query?: object) => (dispatch: any) => {
  dispatch(httpCallStartAction());
  
  newsContentManager.fetchTopicListItemsAsync(query)
  .then((topicItems) => {
    dispatch(fetchTopicListItemsCompleted(topicItems));
  });
};

export const fetchTopicItemsByCategoryAction = (categories: string, query?: object) => (dispatch: any) => {
  dispatch(httpCallStartAction());

newsContentManager.fetchTopicListItemsByCategoryAsync(categories, query)
  .then((topicItems) => {
    dispatch(fetchTopicListItemsCompleted(topicItems));
  })
  .catch(error => dispatch(handleError(error)));;
};

export const fetchTopicItemsCategoriesAction = () => (dispatch: any) => {
  dispatch(httpCallStartAction());

  dispatch(notifyBreadcrumChangeAction(actionTypes.BREADCRUMB_CHANGED_ON_ARCHIVE_PAGE, "Ajankohtaista"));

newsContentManager.fetchNewsCategoriesAsync()
  .then((newsCategories) => {
    dispatch(fetchNewsCategoriesAsyncCompleted(newsCategories));
  });

  newsContentManager.fetchEventCategoriesAsync()
  .then((eventCategories) => {
    dispatch(fetchEventCategoriesCompleted(eventCategories));
  });
};

const fetchEventCategoriesCompleted = (newsCategories: NewsCategory[]) => ({
  meta: {
      httpEnd: true,
    },
  payload: newsCategories,
  type: actionTypes.FETCH_EVENT_CATEGORIES_COMPLETED
});

const fetchNewsCategoriesAsyncCompleted = (newsCategories: NewsCategory[]) => ({
  meta: {
      httpEnd: true,
    },
  payload: newsCategories,
  type: actionTypes.FETCH_NEWS_CATEGORIES_COMPLETED
});

const fetchTopicListItemsCompleted = (eventItems: TopicListItemsDto) => ({
  meta: {
      httpEnd: true,
    },
  payload: eventItems,
  type: actionTypes.FETCH_TOPIC_ITEMS
});

const handleError = (reason: any) => ({
  meta: {
      httpEnd: true,
    },
  payload: {message: reason.message, hasError: true},
  type: actionTypes.FETCH_CONTENT_PAGE_ERROR
});



// WEBPACK FOOTER //
// ./src/components/newsListPage/actions/fetchNewsAndEventsItems.ts